import logger from 'helpers/logger';
import { SystemAndUtilitiesApi } from 'api';
import { apiCallStatus } from 'helpers/constants';
import localStorageHelper from 'helpers/localStorageHelper';
import { getApiActionCreator } from 'helpers/actionHelper';
import * as actionTypes from './constants';

/* ------------------------------------
* Actions Creators
* ------------------------------------ */

const loadEnvironmentPropertiesAction = getApiActionCreator(actionTypes.LOAD_ENVIRONMENT_PROPERTIES);
export const loadEnvironmentProperties = () => {
    return (dispatch) => {
        dispatch(loadEnvironmentPropertiesAction(apiCallStatus.LOADING));
        SystemAndUtilitiesApi.getEnvironmentProperties()
            .then((environmentProperties) => {
                logger.debug('Environment properties successfully loaded');
                localStorageHelper.nonEncrypted.setItem('environmentProperties', environmentProperties);

                dispatch(loadEnvironmentPropertiesAction(apiCallStatus.SUCCESS, environmentProperties));
            }, (err) => {
                dispatch(loadEnvironmentPropertiesAction(apiCallStatus.ERROR, null, err));
            });
    };
};
